import { message } from 'antd'

/** antd v3 message duration is in seconds (not ms). */
export const TOAST_DURATION_SEC = 10

export const showSuccessToast = (content, duration = TOAST_DURATION_SEC) =>
  message.success(content, duration)

export const showErrorToast = (content, duration = TOAST_DURATION_SEC) =>
  message.error(content, duration)
